import LoginForm from '../../components/login/LoginForm';
import { withSubmitApiCall } from '../../components/higher-order/withSubmitApiCall';
import { login } from '../../services/authentication';

const LoginFormContainer = withSubmitApiCall(login)(LoginForm);

export default LoginFormContainer;
